import axios from '@/lib/axios';
import { PurchaseOrderContractTaskComment } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0942. 発注案件契約タスクコメント編集
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_contract_tasks/:purchase_order_contract_task_id/purchase_order_contract_task_comments/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  id: number;
  content: string;
  content_json: string;
};
const updatePurchaseOrderContractTaskComment = (props: Props): Promise<PurchaseOrderContractTaskComment> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_contract_tasks/${props.task_id}/purchase_order_contract_task_comments/${props.id}`,
    props
  );
};

export const useUpdatePurchaseOrderContractTaskComment = () => {
  return useMutation({
    mutationFn: updatePurchaseOrderContractTaskComment,
  });
};
